import './HeaderSearch.scss';
import Component from './HeaderSearch.js';
export default Component;
